var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6141C15.2877 17.0134 15.6547 17.3439 16.0761 17.583C16.4975 17.8221 16.9636 17.9643 17.4426 17.9999C17.9216 18.0355 18.4024 17.9638 18.8523 17.7895C19.3023 17.6151 19.7109 17.3424 20.0504 16.9897L22.0599 14.9029C22.6699 14.247 23.0075 13.3684 22.9999 12.4565C22.9922 11.5446 22.64 10.6723 22.0191 10.0275C21.3981 9.38262 20.5581 9.01684 19.68 9.00892C18.8019 9.001 17.9559 9.35155 17.3243 9.98509L16.1722 11.1745",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.4035C16.7123 15.0042 16.3453 14.6737 15.9239 14.4346C15.5025 14.1955 15.0364 14.0533 14.5574 14.0177C14.0784 13.982 13.5976 14.0538 13.1477 14.2281C12.6977 14.4024 12.2891 14.6752 11.9496 15.0279L9.94013 17.1147C9.33006 17.7706 8.9925 18.6492 9.00013 19.5611C9.00776 20.473 9.35998 21.3453 9.98092 21.9901C10.6019 22.635 11.4419 23.0007 12.32 23.0087C13.1981 23.0166 14.0441 22.666 14.6757 22.0325L15.8211 20.843",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.a3c4ec581e845bc87faed3d81a71536b.svg";
export { ForwardRef as ReactComponent };